<div class="sub-menu" *ngrxLet="filteredOrganizations$; let orgs">
  <div class="overlay" (click)="onMenuClosed.emit()"></div>
  <div class="sub-menu-inner">
    <div class="inner h-100">
      <div class="active-organization organization-item title flex-row start-center gap-8">
        @if (activeOrganization) {
          <ui-avatar
            class="org-avatar"
            [name]="activeOrganization.settings.orgName"
            [color]="activeOrganization.settings.orgColor"
          ></ui-avatar>
          <span uiTruncateText class="truncated-name">{{ activeOrganization.settings.orgName }}</span>
        }
      </div>
      <hr class="hr" style="margin: 12px 8px 12px 8px" />
      @if (userOrganizations.length > 8) {
        <div class="mt-8">
          <ui-search
            [placeholder]="'SIDEBAR.SEARCH_ORGANIZATION_PLACEHOLDER' | translate"
            [heightPx]="40"
            [formControl]="searchControl"
          ></ui-search>
        </div>
      }
      <div class="flex-col h-100 organization-list-wrapper">
        <div
          *ngFor="let org of orgs"
          class="organization-item list flex-row start-center gap-8"
          (click)="switchOrg(org.id)"
        >
          <ui-avatar
            class="org-avatar selectable"
            [name]="org.name"
            [color]="org.color"
            [fontSize]="10"
          ></ui-avatar>
          <span uiTruncateText class="truncated-name">{{ org.name }}</span>
        </div>
      </div>
      <hr class="hr" style="margin: 0px 8px 8px 8px" />
    </div>
  </div>
</div>
